function hamburger() {
    $ = jQuery;

    $('#js-burger').on('click', () => {
        $('.header-menu').addClass('active');
        $('.header__overlay').addClass('active');
        $('html').addClass('block');
    })
    $('#js-hide-burger').on('click', () => {
        closeMenu();
    })
    $('.header__overlay').on('click', () => {
        closeMenu();
    })

    const closeMenu = () => {
        $('.header-menu').removeClass('active');
        $('.header__overlay').removeClass('active');
        $('html').removeClass('block');
        $('.header-switcher__countries-list').removeClass('active');
        $('.header-switcher__icon').removeClass('active');
    }
    
}

export default hamburger;